export default {
  SET_AMOUNT(state, amount) {
    state.amount = amount;
  }
};
